import { useEffect, useMemo, useRef } from 'react'
import { useInfiniteScroll } from '../../../../../../hooks/useInfiniteScroll'
import { useMeetingsExpertHistoryQuery } from '../../../../../../services/hooks/meetings/queries/useMeetingsExpertHistory'
import { type ExpertDomain } from '../../../../../../types/domain/expert-domain'
import { HistoryDetailLine } from '../../components/HistoryDetailLine'

interface Props {
  expert: ExpertDomain
}

export const HistoricData = ({ expert }: Props) => {
  const tableContainerRef = useRef<HTMLDivElement>(null)

  const {
    data,
    hasNextPage,
    fetchNextPage,
    refetch,
  } = useMeetingsExpertHistoryQuery(expert.id, {
    page: 1,
    take: 10,
    search: '',
  })

  const rows = useMemo(() => {
    return (
      data?.pages?.reduce((acc: any, item: any) => {
        return [...acc, ...item.data]
      }, []) || []
    )
  }, [data?.pages])

  useInfiniteScroll(tableContainerRef, hasNextPage, fetchNextPage)

  useEffect(() => {
    refetch()
  }, [expert])

  return (
    <div>
      {rows?.length === 0 && (
        <p className="flex items-center justify-center h-16 text-xs font-semibold text-center opacity-50 md:text-sm text-grey-700">
          Nenhum registro encontrado
        </p>
      )}

      <div className="overflow-y-auto h-96" ref={tableContainerRef}>
        {rows?.map((row: any) => (
          <HistoryDetailLine key={row.id} info={row} />
        ))}
      </div>
    </div>
  )
}
